export default {
    realtor: {
        title: 'Realtor discount',
        subtitle: 'A special gift for you',
        body: `
            <p>Thank your realtor for this one! Through our partner program, they were able to send you this special offer. Think of it as a house-warming gift to you!</p>
            <p>Make sure to thank your realtor and also when you're done checking out we'll give you a referral code worth $300 to pass on peace of mind.</p>
        `,
        amount: "- $ 400.00"
    },

    promotional: {
        title: 'Promotional discount',
        subtitle: 'ADT offers all basic systems for free with a 3 year monitoring contract',
        body: `
        <p>Every ADT Dealer offers the Essential system for free with a 3 year monitoring contract. This includes a Control Panel, 1 Motion Sensor, up to 3 door sensors for your exterior doors, and finally a yard sign. </p>

        <p>Furthermore, the Essential system includes some functional pieces you don’t really get hands on with. This includes a GSM cellular radio, a 95 db siren, and a back-up battery.</p>

        <p>Many dealers try to position extra door sensors and equipment for free. Any offer deviating from this promotional discount is generally dependent on having a landline monitored system. </p>
        `,
        amount: "- $ 850.00"
    },

    truesecurity: {
        title: 'truesecurity discount',
        subtitle: 'A special gift for you',
        body: `
        <p>By purchasing online through truesecurity you’ll receive $300.00 off your total system cost. Awesome right?</p>
        `,
        amount: "- $ 300.00"
    },

    totalInvestment: {
        title: 'Total Investment',
        subtitle: 'This is the total upfront cost of your system. This includes',
        body: ``,
        amount: null,
        
    }
}
